export default "__VITE_ASSET__Blgu4FFY__"